export default {
  Header: {
    LogoAltText: 'CareQuilt Logo',
    FindCareGiver: 'Find Your Caregiver',
    BecomeCaregiver: 'Become a Caregiver',
  },
  Footer: {
    About: 'About',
    FAQ: 'FAQ',
    Contact: 'Contact',
    ForCareGivers: 'For Caregivers',
    TermsConditions: 'Terms & Conditions',
    PrivacyPolicy: 'Privacy Policy',
  },
  SalaryDetails: {
    PayPerHour: '#{currency}#{formatedHourlyRate}/hr',
    HoursPerWeek: '#{hoursPerWeek} hrs/week',
    Shifts: '#{numShifts} shifts',
    SalaryInfo: '#{payPerHour} • #{hoursPerWeekString} • #{shifts}',
    PayPerWeek: '#{currency}#{formatedWeeklyRate}/week',
  },
  JobBoardTitle: {
    Title: 'Find your next<br />great opportunity',
    SubTitle: 'Join our team of passionate caregivers working to make a difference.<br />Explore open positions and find where you belong.',
  },
  JobListings: {
    JobTitle: {
      CaregiverType: {
        PSW: 'Personal Support Worker - #{neighborhood}, #{city}',
        DSW: 'Developmental Support Worker - #{neighborhood}, #{city}',
        RN: 'Registered Nurse - #{neighborhood}, #{city}',
        PAB: 'Préposé aux bénéficiaires - #{neighborhood}, #{city}',
        CNA: 'Certified Nursing Assistant - #{neighborhood}, #{city}',
        RPN: 'Registered Practical Nurse - #{neighborhood}, #{city}',
        RNA: 'Registered Nursing Assistant - #{neighborhood}, #{city}',
        HCA: 'Health Care Aide - #{neighborhood}, #{city}',
        PSW_STUDENT: 'Personal Support Worker Student - #{neighborhood}, #{city}',
        NURSING_STUDENT: 'Nursing Student - #{neighborhood}, #{city}',
        CSW: 'Community Service Worker - #{neighborhood}, #{city}',
        SSW: 'Social Service Worker - #{neighborhood}, #{city}',
        UNACCREDITED: 'Caregiving Companion - #{neighborhood}, #{city}',
      },
    },
    PositionsAvailable: '#{length} Positions Available',
    FindPerfectCaregiving: 'Find your perfect caregiving role and join our team',
    ViewDetails: 'View Details',
  },
};
